import { render, staticRenderFns } from "./c_select.vue?vue&type=template&id=0c5b119e&scoped=true"
import script from "./c_select.vue?vue&type=script&lang=js"
export * from "./c_select.vue?vue&type=script&lang=js"
import style0 from "./c_select.vue?vue&type=style&index=0&id=0c5b119e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b119e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5b119e')) {
      api.createRecord('0c5b119e', component.options)
    } else {
      api.reload('0c5b119e', component.options)
    }
    module.hot.accept("./c_select.vue?vue&type=template&id=0c5b119e&scoped=true", function () {
      api.rerender('0c5b119e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_select.vue"
export default component.exports